import React, { FC } from 'react'
import { IDNameDescriptionItemSelect } from '../../components/_IDNameDescriptionItemSelect'
import PolicyInput from '../../components/_PolicyInput'
import { Select } from 'antd'
import CompDatePicker from '../../components/compDatePicker/_CompDatePicker'
import { IDNameDescriptionDictionary } from '../../models/Site'
import CheckBox from '../../components/_CheckBox'

interface Props {
    policy: any;
    onAdditionalDetailsChange: (field: string, value: any) => void;
    onChangeAuthorizedToDrive: (field: string, value: any) => void;
    authorizedToDrive: IDNameDescriptionDictionary;
    authorizedToDriveSelected: number;
    onChangeDriverDetails: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onChangeDriverYoungGenderDetails: (value: string) => void;
    genders: any[];
    onYoungDriverCustomerAgeChange: (field: string, date: Date) => void;
    ageYoungDriver: number;
    onYoungDriverCustomerSeniorityChange: (field: string, date: Date) => void;
    driverYoungSeniority: number;
    onChangeDriverMainGenderDetails: (value: string) => void;
    onMainDriverCustomerAgeChange: (field: string, date: Date) => void;
    ageMainDriver: number;
    onMainDriverCustomerSeniorityChange: (field: string, date: Date) => void;
    driverMainSeniority: number;
    passedTypeOfInsurance: IDNameDescriptionDictionary;
}


const DriversDetails: FC<Props> = ({
    policy,
    onAdditionalDetailsChange,
    onChangeAuthorizedToDrive,
    authorizedToDrive,
    authorizedToDriveSelected,
    onChangeDriverDetails,
    onChangeDriverYoungGenderDetails,
    genders,
    onYoungDriverCustomerAgeChange,
    ageYoungDriver,
    onYoungDriverCustomerSeniorityChange,
    driverYoungSeniority,
    onChangeDriverMainGenderDetails,
    onMainDriverCustomerAgeChange,
    ageMainDriver,
    onMainDriverCustomerSeniorityChange,
    driverMainSeniority,
    passedTypeOfInsurance,
}) => {
    return (
        <>
            <div className="row-items">
                <div className="tab-content-title section-title" style={{ marginTop: '20px', fontWeight: '600', padding: '5px 20px' }}>
                    פרטי נהגים
                </div>
            </div>
            <div className="row-items">
                <div className="item">
                    <div className="title">
                        רשאים לנהוג
                    </div>
                    <IDNameDescriptionItemSelect
                        OnChange={onChangeAuthorizedToDrive}
                        Options={authorizedToDrive}
                        Id={"driversType"}
                        Value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.driversType != undefined && policy.policyAdditionDetails.driversType >= 0 ?
                            policy.policyAdditionDetails.driversType : -1}
                    />
                    <div className='error-message'>
                        {/* *{this.state.errors.requiredField} */}
                    </div>
                </div>
            </div>
            <div className="row-items">
                {policy && policy.policyAdditionDetails && policy.policyAdditionDetails.driversType
                    && policy.policyAdditionDetails.driversType > 0 ?
                    <>
                        {authorizedToDriveSelected < 2 &&
                            <>
                                <div className="item">
                                    <div className="title">
                                        שם מלא
                                    </div>
                                    <div className='value'>
                                        {/* <input type="text" name='fullName'
                                                            value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.youngDriverCustomer
                                                                && policy.policyAdditionDetails.youngDriverCustomer.fullName ? policy.policyAdditionDetails.youngDriverCustomer.fullName : ''}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e, 'young')}
                                                            disabled={!edit} /> */}
                                        <PolicyInput
                                            type='text' name='driverYoungFirstName'
                                            value={policy && policy.policyAdditionDetails
                                                && policy.policyAdditionDetails.driverYoungFirstName ? policy.policyAdditionDetails.driverYoungFirstName : ''}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e)}
                                        />

                                        <PolicyInput
                                            type='text' name='driverYoungLastName'
                                            value={policy && policy.policyAdditionDetails
                                                && policy.policyAdditionDetails.driverYoungLastName ? policy.policyAdditionDetails.driverYoungLastName : ''}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e)}
                                        />
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="title">
                                        ת.ז. נהג צעיר
                                    </div>
                                    <div className='value'>
                                        {/* <input type="text" name='identifier' value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.youngDriverCustomer
                                                            && policy.policyAdditionDetails.youngDriverCustomer.identifier ? policy.policyAdditionDetails.youngDriverCustomer.identifier : ''}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e, 'young')}
                                                            disabled={!edit} /> */}
                                        <PolicyInput
                                            type='text' name='driverYoungIdentifier'
                                            value={policy && policy.policyAdditionDetails 
                                                && policy.policyAdditionDetails.driverYoungIdentifier ? policy.policyAdditionDetails.driverYoungIdentifier : ''}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e)}
                                        />
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="title">
                                        מגדר
                                    </div>
                                    <Select
                                        placeholder="מגדר"
                                        value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.driverYoungGender !== undefined && policy.policyAdditionDetails.driverYoungGender >= 0 ? String(policy.policyAdditionDetails.driverYoungGender) : undefined}
                                        onChange={onChangeDriverYoungGenderDetails}
                                        style={{ width: '100%' }}
                                        options={genders}
                                    />
                                </div>
                            </>
                        }
                        <div className="item">
                            <div className="title">
                                גיל הנהג הצעיר
                            </div>
                            <div className="value" style={{ display: 'flex', gap: '10px' }}>
                                <CompDatePicker placeholder={'גיל הנהג הצעיר'} value={policy && policy.policyAdditionDetails 
                                    && policy.policyAdditionDetails.driverYoungBirthDate ? policy.policyAdditionDetails.driverYoungBirthDate : null}
                                    onChange={(date: Date) => onYoungDriverCustomerAgeChange("driverYoungBirthDate", date)} />

                                {ageYoungDriver > 0 ? ageYoungDriver : ''}
                            </div>
                            <div className='error-message'>
                                {/* *{this.state.errors.requiredField} */}
                            </div>
                        </div>
                        <div className="item">
                            <div className="title">
                                ותק הנהג הצעיר
                            </div>
                            <div className="value" style={{ display: 'flex', gap: '10px' }}>
                                <CompDatePicker placeholder={'ותק הנהג הצעיר'} value={policy && policy.policyAdditionDetails 
                                    && policy.policyAdditionDetails.driverYoungSeniorityDate ? policy.policyAdditionDetails.driverYoungSeniorityDate : null}
                                    onChange={(date: Date) => onYoungDriverCustomerSeniorityChange("driverYoungSeniorityDate", date)} />
                                {driverYoungSeniority > 0 ? driverYoungSeniority : ''}
                            </div>
                            <div className='error-message'>
                                {/* *{this.state.errors.requiredField} */}
                            </div>
                        </div>

                    </> : <></>
                }
            </div>
            {policy && policy.policyAdditionDetails && policy.policyAdditionDetails.driversType !== undefined
                && policy.policyAdditionDetails.driversType >= 0 && policy.policyAdditionDetails.driversType < 2 ?
                <div className='row-items'>

                    <div className="item">

                        <div className="title">
                            שם מלא
                        </div>
                        <div className='value'>
                            {/* <input type="text" name='fullName'
                                                    value={policy.policyAdditionDetails && policy.policyAdditionDetails.mainDriverCustomer
                                                        && policy.policyAdditionDetails.mainDriverCustomer.fullName ? policy.policyAdditionDetails.mainDriverCustomer.fullName : ''}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e, 'main')}
                                                    disabled={!edit} /> */}
                            <PolicyInput
                                type='text' name='driverMainFirstName'
                                value={policy && policy.policyAdditionDetails 
                                    && policy.policyAdditionDetails.driverMainFirstName ? policy.policyAdditionDetails.driverMainFirstName : ''}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e)}
                            />

                            <PolicyInput
                                type='text' name='driverMainLastName'
                                value={policy && policy.policyAdditionDetails 
                                    && policy.policyAdditionDetails.driverMainLastName ? policy.policyAdditionDetails.driverMainLastName : ''}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e)}
                            />
                        </div>
                    </div>


                    <div className="item">

                        <div className="title">
                            ת.ז. נהג עיקרי
                        </div>
                        <div className='value'>
                            {/* <input type="text" name='identifier' value={policy.policyAdditionDetails && policy.policyAdditionDetails.mainDriverCustomer
                                                    && policy.policyAdditionDetails.mainDriverCustomer.identifier ? policy.policyAdditionDetails.mainDriverCustomer.identifier : ''}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e, 'main')}
                                                    disabled={!edit} /> */}
                            <PolicyInput
                                type='text' name='driverMainIdentifier'
                                value={policy && policy.policyAdditionDetails 
                                    && policy.policyAdditionDetails.driverMainIdentifier ? policy.policyAdditionDetails.driverMainIdentifier : ''}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeDriverDetails(e)}
                            />
                        </div>
                    </div>
                    <div className="item">

                        <div className="title">
                            מגדר
                        </div>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="מגדר"
                            value={policy && policy.policyAdditionDetails
                                && policy.policyAdditionDetails.driverMainGender !== undefined && policy.policyAdditionDetails.driverMainGender >= 0
                                ? String(policy.policyAdditionDetails.driverMainGender) : undefined}
                            onChange={onChangeDriverMainGenderDetails}
                            options={genders}
                        />

                    </div>
                    <div className="item">

                        <div className="title">
                            גיל נהג עיקרי
                        </div>
                        <div className="value" style={{ display: 'flex', gap: '10px' }}>

                            {/* <CompDatePicker disabled={!edit} placeholder={'גיל הנהג עיקרי'} value={policy.policyAdditionDetails && policy.policyAdditionDetails.mainDriverCustomer && policy.policyAdditionDetails.mainDriverCustomer.dateOfBirth ?
                                                    policy.policyAdditionDetails.mainDriverCustomer.dateOfBirth : ''}
                                                    onChange={(date: Date) => onMainDriverCustomerAgeChange("dateOfBirth", date)} />
                                                {ageMainDriver} */}
                            <CompDatePicker placeholder={'גיל הנהג עיקרי'} value={policy && policy.policyAdditionDetails 
                                && policy.policyAdditionDetails.driverMainBirthDate ? policy.policyAdditionDetails.driverMainBirthDate : null}
                                onChange={(date: Date) => onMainDriverCustomerAgeChange("driverMainBirthDate", date)} />

                            {ageMainDriver > 0 ? ageMainDriver : ''}

                        </div>
                    </div>
                    <div className="item">

                        <div className="title">
                            ותק נהג עיקרי
                        </div>
                        <div className="value" style={{ display: 'flex', gap: '10px' }}>

                            {/* <CompDatePicker disabled={!edit} placeholder={'ותק נהג עיקרי'} value={driverMainSeniorityDate}
                                                    onChange={(date: Date) => onMainDriverCustomerSeniorityChange("driverLicensSeniority", date)} />
                                                {driverMainSeniority} */}
                            <CompDatePicker placeholder={'ותק נהג עיקרי'} value={policy && policy.policyAdditionDetails
                                && policy.policyAdditionDetails.driverMainSeniorityDate ? policy.policyAdditionDetails.driverMainSeniorityDate : null}
                                onChange={(date: Date) => onMainDriverCustomerSeniorityChange("driverMainSeniorityDate", date)} />
                            {driverMainSeniority > 0 ? driverMainSeniority : ''}
                        </div>
                    </div>
                </div> : null


            }

            <div className="row-items">
                <div className="tab-content-title section-title" style={{ marginTop: '20px', fontWeight: '600', padding: '5px 20px' }}>
                    עבר ביטוחי
                </div>
            </div>
            <div className="row-items">
                <div className="item">
                    <div className="title">
                        שנה קודמת
                    </div>
                    <div className="value">
                        <IDNameDescriptionItemSelect
                            OnChange={onAdditionalDetailsChange}
                            Options={passedTypeOfInsurance}
                            Id={"passedInsuranceTypeLastYear"}
                            Value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.passedInsuranceTypeLastYear}
                        />
                    </div>
                    <div className='error-message'>
                    </div>
                </div>

                <div className="item">
                    <div className="title">
                        תביעות
                    </div>
                    <PolicyInput
                        type='number'
                        value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.sueNumber1
                            ? String(policy.policyAdditionDetails.sueNumber1) : '0'}
                        onChange={(e) => onAdditionalDetailsChange("sueNumber1", e.target.value)}
                    />
                    <div className='error-message'>
                    </div>
                </div>

                <div className="item">
                    <div className="title">
                        שנתיים קודמות
                    </div>
                    <div className="value">
                        <IDNameDescriptionItemSelect
                            OnChange={onAdditionalDetailsChange}
                            Options={passedTypeOfInsurance}
                            Id={"passedInsuranceType2YearsAgo"}
                            Value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.passedInsuranceType2YearsAgo}
                        />
                    </div>
                    <div className='error-message'>
                    </div>
                </div>

                <div className="item">
                    <div className="title">
                        תביעות
                    </div>
                    <PolicyInput
                        type='number'
                        value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.sueNumber2
                            ? String(policy.policyAdditionDetails.sueNumber2) : '0'}
                        onChange={(e) => onAdditionalDetailsChange("sueNumber2", e.target.value)}
                    />
                    <div className='error-message'>
                    </div>
                </div>

                <div className="item">
                    <div className="title">
                        שלוש שנים קודמות
                    </div>
                    <div className="value">
                        <IDNameDescriptionItemSelect
                            OnChange={onAdditionalDetailsChange}
                            Options={passedTypeOfInsurance}
                            Id={"passedInsuranceType3YearsAgo"}
                            Value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.passedInsuranceType3YearsAgo}
                        />
                    </div>
                    <div className='error-message'>
                    </div>
                </div>

                <div className="item">
                    <div className="title">
                        תביעות
                    </div>
                    <PolicyInput
                        type='number'
                        value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.sueNumber3
                            ? String(policy.policyAdditionDetails.sueNumber3) : '0'}
                        onChange={(e) => onAdditionalDetailsChange("sueNumber3", e.target.value)}
                    />
                    <div className='error-message'>
                    </div>
                </div>
            </div>
            <div className="row-items">

                <div className="item">
                    <div className="title">
                        תביעות גוף
                    </div>
                    <PolicyInput
                        type='number'
                        value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.bodyClaimsAmount &&
                            policy.policyAdditionDetails.bodyClaimsAmount >= 0 ?
                            String(policy.policyAdditionDetails.bodyClaimsAmount) : '0'}
                        // value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.bodyClaimsAmount
                        //      ? String(policy.policyAdditionDetails.bodyClaimsAmount) : '0'}
                        onChange={(e) => onAdditionalDetailsChange("bodyClaimsAmount", e.target.value)}
                    />
                    <div className='error-message'>
                    </div>
                </div>


                <div className="item">
                    <div className="title">
                        שלילות רישיון
                    </div>
                    <PolicyInput
                        type='number'
                        value={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.revocationsAmount
                            ? String(policy.policyAdditionDetails.revocationsAmount) : '0'}
                        onChange={(e) => onAdditionalDetailsChange("licenseDenialNumber", e.target.value)}
                    />
                    <div className='error-message'>
                    </div>
                </div>

                <div className="item">
                    <div className="title">
                        נוסע בשבת
                    </div>
                    <div className="value">
                        <CheckBox
                            checked={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.drivingOnShabbat
                                ? policy.policyAdditionDetails.drivingOnShabbat : false}
                            onChange={(e) => onAdditionalDetailsChange("drivingOnShabbat", e.target.checked)}
                        />
                    </div>
                </div>

                <div className="item">
                    <div className="title">
                        כינון אוטומטי
                    </div>
                    <div className="value">
                        <CheckBox
                            checked={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.autodirection
                                ? policy.policyAdditionDetails.autodirection : false}
                            onChange={(e) => onAdditionalDetailsChange("autodirection", e.target.checked)}
                        />
                    </div>
                </div>

                <div className="item">
                    <div className="title">
                        חדש תמורת ישן
                    </div>
                    <div className="value">
                        <CheckBox
                            checked={policy && policy.policyAdditionDetails && policy.policyAdditionDetails.newForOld
                                ? policy.policyAdditionDetails.newForOld : false}
                            onChange={(e) => onAdditionalDetailsChange("newForOld", e.target.checked)}
                        />
                    </div>
                </div>
            </div>

        </>
    )
}

export default DriversDetails